import { render, staticRenderFns } from "./CadastrarEditarFuncaoDialog.vue?vue&type=template&id=83079270"
import script from "./CadastrarEditarFuncaoDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarFuncaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports